module.exports = __webpack_public_path__ + "img/mgw-achievement.a189d7b5.png";